export const articleData = {
  1: {
    id: 1,
    slug: 'top-star-scandal-leak',
    title: '顶流男星深夜密会网红，酒店监控视频独家曝光',
    excerpt: '据知情人士透露，该顶流男星在某五星级酒店与神秘女子共度三小时，全程被监控拍下。女方疑似某短视频平台千万粉丝网红，两人此前多次在社交平台互动引发猜测。',
    category: '明星黑料',
    categorySlug: 'star-scandal',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20hotel%20corridor%20at%20night%20with%20dramatic%20lighting%20shadows%20and%20mysterious%20atmosphere%20cinematic%20photography%20style%20with%20warm%20amber%20tones%20and%20deep%20blacks%20luxury%20hotel%20interior%20with%20dim%20lights%20suspenseful%20mood&width=1200&height=600&seq=article-hero-01&orientation=landscape',
    author: {
      name: '爆料小能手',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20looking%20Chinese%20journalist%20portrait%20with%20serious%20expression%20clean%20studio%20background%20headshot%20photography&width=80&height=80&seq=author-01&orientation=squarish',
      role: '资深娱乐记者',
    },
    publishedAt: '2026-07-07T14:30:00',
    updatedAt: '2026-07-07T16:45:00',
    views: 1285000,
    comments: 32567,
    tag: '独家',
    content: `
      <p>【51爆料独家报道】近日，有知情人士向本网爆料，某当红顶流男星于上周末深夜时分，被拍到在上海某五星级酒店与一名神秘女子共度良宵，全程被酒店监控探头拍下。</p>
      
      <h2>酒店监控曝光：深夜密会三小时</h2>
      
      <p>根据爆料人提供的监控画面显示，该男星于当晚23:15左右独自抵达酒店后门，通过员工通道进入酒店。约15分钟后，一名身穿黑色连衣裙、头戴渔夫帽的女子出现在同一入口，在确认无人跟踪后迅速进入酒店。</p>
      
      <p>监控显示两人在酒店3楼的行政酒廊短暂会面后，一同搭乘电梯前往22楼总统套房。直到凌晨2:30左右，该女子才从房间离开，此时距离她进入酒店已经过去约三小时。</p>
      
      <h2>神秘女子身份曝光</h2>
      
      <p>经过多方核实，该神秘女子疑似为某短视频平台拥有千万粉丝的知名网红"甜心小兔"。两人此前多次在社交平台互动，包括互相点赞、评论等，但一直以"朋友"相称。</p>
      
      <p>值得注意的是，就在事发前两天，"甜心小兔"曾在直播中暗示自己正在与一位"圈内人"交往，但拒绝透露对方身份。时间线上与此事件高度吻合。</p>
      
      <h2>粉丝反应两极分化</h2>
      
      <p>消息传出后，该男星的粉丝群体出现明显分裂。一部分粉丝表示"只要哥哥开心就好"，另一部分则直言"不能接受"，更有极端粉丝扬言要脱粉甚至回踩。</p>
      
      <p>该男星的超话社区在消息传出的24小时内，讨论量暴涨300%，话题#顶流男星深夜密会#一度冲上微博热搜榜首，阅读量突破5亿。</p>
      
      <h2>经纪公司紧急公关</h2>
      
      <p>截至发稿前，该男星所属经纪公司已发布紧急声明，称"所谓密会纯属恶意造谣，两人只是普通朋友聚餐"，并表示将追究造谣者的法律责任。但声明中并未对监控画面的真实性做出正面回应。</p>
      
      <p>本网将持续关注此事的后续发展，敬请期待更多独家报道。</p>
    `,
    relatedArticles: [2, 3, 4],
    faq: [
      {
        question: '这次爆料的顶流男星到底是谁？',
        answer: '根据多方信息交叉验证，该男星为近年活跃于影视综艺领域的顶流艺人，因涉及隐私保护暂不公开姓名，但圈内人士均可对号入座。',
      },
      {
        question: '监控视频的真实性如何？',
        answer: '爆料人提供了完整的监控时间轴和多角度画面截图，时间戳与酒店记录完全吻合。本网已委托第三方技术团队进行鉴定，初步判断视频未经过剪辑或伪造。',
      },
      {
        question: '为什么51爆料能拿到独家监控视频？',
        answer: '51爆料网拥有覆盖全国的线人网络，此次监控视频来源于酒店内部员工匿名提供。我们始终保护线人隐私，不会透露任何线人信息。',
      },
    ],
    seoTitle: '顶流男星深夜密会网红酒店监控视频独家曝光 - 51爆料网',
    seoDescription: '51爆料独家报道：某顶流男星深夜在上海五星级酒店密会神秘女子，监控视频全程拍下。女方疑似某平台千万粉丝网红，两人此前社交平台互动频繁。51爆料网独家追踪。',
  },
  2: {
    id: 2,
    slug: 'influencer-divorce-dark-secret',
    title: '知名网红夫妻离婚内幕：第三者竟是其经纪人，聊天记录全曝光',
    excerpt: '百万粉丝网红夫妇突然宣布离婚，背后真相令人震惊。据圈内人爆料，第三者竟是女方多年经纪人，两人秘密交往超过两年。大量暧昧聊天记录已在粉丝群流传。',
    category: '网红吃瓜',
    categorySlug: 'influencer-gossip',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20split%20composition%20showing%20a%20fractured%20relationship%20concept%20with%20warm%20moody%20lighting%20emotional%20atmosphere%20modern%20interior%20setting%20with%20shadows%20and%20contrast%20cinematic%20photography%20style%20tension&width=1200&height=600&seq=article-hero-02&orientation=landscape',
    author: {
      name: '吃瓜特派员',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20journalist%20portrait%20with%20professional%20look%20clean%20studio%20background%20confident%20expression%20headshot%20photography&width=80&height=80&seq=author-02&orientation=squarish',
      role: '娱乐调查记者',
    },
    publishedAt: '2026-07-07T10:15:00',
    updatedAt: '2026-07-07T15:00:00',
    views: 986000,
    comments: 21890,
    tag: '热瓜',
    content: `
      <p>【51爆料独家报道】拥有超过800万粉丝的网红夫妻"老K和糖糖"今日突然宣布离婚，原本看似恩爱的模范夫妻为何走到这一步？51爆料独家获得内幕消息，真相令人大跌眼镜。</p>
      
      <h2>轰动全网的离婚声明</h2>
      
      <p>今日上午10点，"老K和糖糖"同时发布微博声明，宣布结束五年婚姻关系。声明中仅表示"因性格不合和平分手"，但这一说法显然无法让粉丝信服。毕竟就在一周前，两人还合体直播秀恩爱，销售额突破千万。</p>
      
      <h2>惊天秘密：第三者竟是身边人</h2>
      
      <p>据51爆料独家获悉，导致这段婚姻破裂的真正原因，是女方糖糖与其经纪人陈某之间存在长达两年之久的秘密恋情。陈某不仅是糖糖的经纪人，还是老K多年的好兄弟，三人曾多次同框出镜。</p>
      
      <p>一位不愿具名的圈内人士透露："老K是两个月前无意中发现了两人的聊天记录，内容之露骨让人不忍卒读。老K当时整个人都崩溃了，一度想要轻生。"</p>
      
      <h2>聊天记录铁证如山</h2>
      
      <p>本网获得的部分聊天记录显示，糖糖与经纪人陈某的暧昧关系至少从两年前就已开始。聊天内容包含大量亲密对话、约会安排，甚至还有两人讨论如何欺骗老K的具体方案。</p>
      
      <p>更令人愤怒的是，在聊天记录中，陈某多次以经纪人身份为糖糖安排工作行程，实则是为两人创造约会机会。而毫不知情的老K在此期间一直将陈某视为最好的朋友。</p>
      
      <h2>粉丝反应：心疼老K</h2>
      
      <p>内幕曝光后，舆论几乎一边倒地支持老K。大量粉丝涌入糖糖和陈某的社交账号留言抨击，两人的粉丝数在数小时内暴跌超过百万。</p>
      
      <p>话题#心疼老K#迅速登上热搜，网友们纷纷表示："最好的兄弟和最爱的女人同时背叛，这种伤害太致命了。"</p>
      
      <h2>后续发展</h2>
      
      <p>据悉，老K已经聘请了律师团队处理离婚事宜，将争取孩子的抚养权和最大限度的财产分割。而糖糖方面至今未对聊天记录事件做出正式回应。</p>
      
      <p>51爆料网将持续关注此事进展，为吃瓜群众带来第一手消息。</p>
    `,
    relatedArticles: [1, 3, 5],
    faq: [
      {
        question: '老K和糖糖的粉丝数现在怎么样了？',
        answer: '事件曝光后，老K的粉丝数反而增长了约50万，而糖糖和陈某的账号分别掉粉120万和80万。',
      },
      {
        question: '两人的孩子归谁抚养？',
        answer: '目前双方正在进行抚养权协商，据悉老K方面提供了大量有利证据，争取孩子抚养权的胜算较大。',
      },
    ],
    seoTitle: '网红夫妻离婚内幕第三者竟是经纪人聊天记录曝光 - 51爆料网',
    seoDescription: '百万粉丝网红夫妻老K和糖糖突然宣布离婚，51爆料独家获悉第三者竟是女方经纪人。大量暧昧聊天记录流出，揭秘这段长达两年的秘密恋情。',
  },
  3: {
    id: 3,
    slug: 'talent-show-rigging-exposed',
    title: '选秀节目黑幕大揭底：导师私下收取巨额贿赂操控比赛结果',
    excerpt: '某热播选秀节目被曝存在严重黑幕操作，多位参赛选手联合实名举报。据称导师团队收受选手经纪公司贿赂，提前内定前三名。节目组已启动内部调查。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20performance%20scene%20with%20spotlight%20and%20dark%20shadows%20mysterious%20atmosphere%20behind%20the%20scenes%20talent%20show%20setting%20with%20dramatic%20contrast%20lighting%20cinematic%20style%20judges%20panel&width=1200&height=600&seq=article-hero-03&orientation=landscape',
    author: {
      name: '真相调查员',
      avatar: 'https://readdy.ai/api/search-image?query=Investigative%20journalist%20portrait%20with%20serious%20expression%20professional%20look%20clean%20background%20headshot%20photography&width=80&height=80&seq=author-03&orientation=squarish',
      role: '调查记者',
    },
    publishedAt: '2026-07-06T22:00:00',
    updatedAt: '2026-07-07T08:00:00',
    views: 756000,
    comments: 15432,
    tag: '独家',
    content: `
      <p>【51爆料独家报道】近期热播的某大型选秀节目被曝存在严重黑幕，多位参赛选手联合实名举报，指控节目导师团队收受巨额贿赂，内定比赛名次。51爆料独家获取了相关证据。</p>
      
      <h2>选手联合举报：名次早已内定</h2>
      
      <p>据参与举报的选手透露，节目在正式录制前，前三名的结果就已经被确定。名次分配完全取决于选手背后经纪公司的"投入"力度，而非选手的真实实力。</p>
      
      <p>"我们的努力和梦想，在资本面前一文不值。"一位参与举报的选手情绪激动地表示，"当你看到那些明显实力不如你的选手被导师疯狂夸赞，而你被刻意贬低的时候，一切就都明白了。"</p>
      
      <h2>贿赂金额触目惊心</h2>
      
      <p>51爆料获得的内部文件显示，选手经纪公司向导师团队支付的"好处费"从50万到500万不等。其中，争夺冠军的选手经纪公司支付的金额最高，据称超过800万元。</p>
      
      <p>这些资金通过多层中间人进行流转，以"咨询费""培训费"等名义入账，手法相当隐蔽。但51爆料已经获取了部分转账记录和中间人的证词。</p>
      
      <h2>导师身份呼之欲出</h2>
      
      <p>虽然举报材料中对导师姓名进行了匿名处理，但根据节目阵容和时间线交叉比对，涉案导师的身份已经基本明确。其中包括一位号称"公正严师"的资深音乐人和一位以"毒舌"著称的流量艺人。</p>
      
      <h2>节目组回应：已启动内部调查</h2>
      
      <p>事件曝光后，节目组官方微博发布声明，表示"高度重视选手举报内容，已启动内部调查程序，将严肃处理任何违规行为"。但该声明被网友批评为"避重就轻""毫无诚意"。</p>
      
      <p>业内人士分析，如果选手举报属实，涉事导师可能面临行业封杀的严重后果，而节目本身也可能被广电总局叫停。</p>
    `,
    relatedArticles: [1, 2, 4],
    faq: [
      {
        question: '涉事节目是哪一档？',
        answer: '基于隐私和法律考虑暂不公开节目名称，但根据公开线索（节目阵容、播出时间等），熟悉娱乐圈的观众应该能对号入座。',
      },
      {
        question: '举报选手的安全能得到保障吗？',
        answer: '举报选手的身份信息已做严格脱敏处理，同时已有公益律师团队为他们提供法律援助，确保他们的合法权益不受侵害。',
      },
    ],
    seoTitle: '选秀节目黑幕导师收受贿赂操控比赛结果选手实名举报 - 51爆料网',
    seoDescription: '某热播选秀节目被曝严重黑幕，多位选手实名举报导师收受巨额贿赂内定名次。51爆料独家获取内部文件和转账记录，揭秘选秀背后的金钱游戏。',
  },
  4: {
    id: 4,
    slug: 'live-streamer-tax-evasion',
    title: '头部主播涉嫌偷税漏税被调查，金额高达数千万',
    excerpt: '税务部门对某头部直播带货主播展开调查，初步查明其通过虚假合同、阴阳账本等手段偷逃税款。该主播年收入超亿元，此次涉案金额令人咋舌。',
    category: '明星黑料',
    categorySlug: 'star-scandal',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20office%20interior%20with%20dramatic%20lighting%20and%20shadows%20serious%20atmosphere%20with%20documents%20on%20desk%20cinematic%20photography%20style%20dark%20moody%20tones%20professional%20setting&width=1200&height=600&seq=article-hero-04&orientation=landscape',
    author: {
      name: '财经调查员',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20journalist%20portrait%20serious%20expression%20business%20attire%20clean%20background%20headshot%20photography&width=80&height=80&seq=author-04&orientation=squarish',
      role: '财经调查记者',
    },
    publishedAt: '2026-07-06T18:45:00',
    updatedAt: '2026-07-07T09:00:00',
    views: 643000,
    comments: 12890,
    tag: '追踪',
    content: `
      <p>【51爆料独家报道】近日，税务稽查部门对某头部直播带货主播展开全面调查。初步查明该主播通过设立多家空壳公司、签订阴阳合同等方式，在近三年内偷逃税款高达数千万元。</p>
      <h2>涉案金额触目惊心</h2>
      <p>据知情人士透露，该主播年带货销售额超过50亿元，个人年收入超亿元。但通过精心设计的避税方案，其实际申报收入仅为真实收入的十分之一。</p>
      <p>调查人员在其住处搜出大量财务凭证和银行流水记录，涉及多个境内外账户的资金往来。其中部分资金通过地下钱庄转移至海外，手法极其隐蔽。</p>
      <h2>虚假合同与阴阳账本</h2>
      <p>该主播的运作模式是：与品牌方签订两份合同，一份为对外公开的低价合同用于税务申报，另一份为真实的补充协议约定实际佣金。差价部分通过第三方壳公司以"咨询费""推广费"等名义收取。</p>
      <p>税务部门已掌握完整的证据链，包括合同原件、银行转账记录、相关人员的证人证言等。</p>
      <h2>或将面临巨额罚款</h2>
      <p>税务律师分析，按照现行税法规定，该主播除需补缴税款外，还将面临税款金额50%至5倍的罚款。如果情节特别严重，甚至可能面临刑事责任。</p>
      <p>目前该主播的所有社交账号处于停更状态，其直播带货业务已全面暂停。51爆料将持续追踪此案进展。</p>
    `,
    relatedArticles: [1, 3],
    faq: [
      { question: '涉案主播是谁？', answer: '为保护调查程序完整性和个人隐私，暂不公开具体身份。但该主播为近两年活跃在头部平台的超头部带货主播，粉丝量超过5000万。' },
      { question: '偷税金额具体是多少？', answer: '初步查明偷逃税款超过3000万元，滞纳金和罚款加总可能突破1亿元。具体金额有待税务部门最终核定。' },
    ],
    seoTitle: '头部主播涉嫌偷税漏税数千万被调查阴阳合同曝光 - 51爆料网',
    seoDescription: '税务部门对某头部主播展开调查，发现其通过虚假合同、阴阳账本等手段偷逃税款数千万。51爆料独家获取内部调查文件，揭开主播偷税真相。',
  },
  5: {
    id: 5,
    slug: 'daily-contest-celebrity-feud',
    title: '两大花旦公开互撕！微博评论区炸了，工作室紧急发声明',
    excerpt: '娱乐圈两大一线女星因新剧番位问题在社交平台公开互呛，双方粉丝已经开战超过24小时，话题阅读量破10亿。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20confrontation%20scene%20with%20two%20silhouettes%20facing%20each%20other%20under%20spotlight%20stage%20setting%20with%20intense%20atmosphere%20cinematic%20lighting%20warm%20and%20cool%20tone%20contrast&width=1200&height=600&seq=article-hero-05&orientation=landscape',
    author: {
      name: '娱乐现场直击',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20reporter%20portrait%20with%20professional%20look%20clean%20background%20headshot%20photography&width=80&height=80&seq=author-05&orientation=squarish',
      role: '娱乐现场记者',
    },
    publishedAt: '2026-07-07T08:00:00',
    updatedAt: '2026-07-07T12:00:00',
    views: 890000,
    comments: 45678,
    tag: '热瓜',
    content: `
      <p>【51爆料独家报道】娱乐圈两大一线女星因新剧番位归属问题在微博公开互呛，引发全网关注。截至发稿前，相关话题阅读量已突破10亿，双方粉丝大战持续升级。</p>
      <h2>起因：番位之争</h2>
      <p>据悉，引爆这场争端的是某古装大IP项目官宣阵容。该剧原定双女主设定，但在官宣海报中，一位女星的名字排在另一位之前。这引发了排位在后的女星方强烈不满。</p>
      <p>当晚，该女星工作室发布声明称"艺人从未同意番位安排"，暗示遭到了不公正对待。随后另一方工作室火速回应"一切以合同为准"，火药味十足。</p>
      <h2>粉丝大战升级</h2>
      <p>双方粉丝迅速集结，在微博、小红书等多个平台展开激烈交锋。从互扒黑历史到对比实绩，从刷屏控评到屠版热搜，战况之激烈前所未见。</p>
      <h2>业内态度</h2>
      <p>多位圈内人士私下表示，番位之争反映了当下娱乐圈的畸形生态。一位知名制片人评论道："现在不是作品好不好，而是谁的名字在前面，这种氛围对行业发展极为不利。"</p>
    `,
    relatedArticles: [3, 2],
    faq: [
      { question: '两位女星到底是谁？', answer: '基于相关方的隐私保护，暂不公开具体姓名。但熟悉娱乐圈的观众不难从近期新剧官宣信息中对号入座。' },
      { question: '番位为什么这么重要？', answer: '番位直接影响艺人的商业价值、代言费用和后续资源获取。一番艺人通常片酬高出30%-50%，因此经纪人团队会不惜代价争取。' },
    ],
    seoTitle: '两大一线女星公开互撕番位之争工作室紧急声明 - 51爆料网',
    seoDescription: '娱乐圈两大花旦因新剧番位问题在微博公开互呛，双方粉丝开战超24小时话题破10亿。51爆料独家跟踪事件全貌。',
  },
  6: {
    id: 6,
    slug: 'daily-contest-idol-dating',
    title: '偶像团体成员深夜约会素人，粉丝脱粉回踩曝更多猛料',
    excerpt: '某当红偶像团体成员被拍到与素人女子深夜约会，举止亲密。粉丝后援会宣布集体脱粉，并爆料该偶像此前多次违反恋爱禁令。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=Night%20street%20scene%20with%20neon%20lights%20and%20romantic%20atmosphere%20couple%20silhouette%20in%20the%20distance%20urban%20cityscape%20at%20night%20cinematic%20photography%20style%20with%20bokeh%20lights&width=1200&height=600&seq=article-hero-06&orientation=landscape',
    author: {
      name: '饭圈观察员',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20journalist%20portrait%20casual%20style%20friendly%20expression%20clean%20background%20headshot&width=80&height=80&seq=author-06&orientation=squarish',
      role: '饭圈文化记者',
    },
    publishedAt: '2026-07-07T06:30:00',
    updatedAt: '2026-07-07T11:00:00',
    views: 720000,
    comments: 28900,
    tag: '热瓜',
    content: `
      <p>【51爆料独家报道】某当红偶像团体成员被拍到深夜与一名素人女子约会，两人举止亲密，全程手牵手漫步街头。照片曝光后，其粉丝后援会宣布集体脱粉，更大规模爆料随之而来。</p>
      <h2>深夜约会画面曝光</h2>
      <p>据爆料人提供的照片显示，该偶像于7月6日深夜11点左右，与一名身穿白色连衣裙的女子出现在北京三里屯附近。两人全程十指紧扣，不时亲密耳语，关系非比寻常。</p>
      <p>照片中可以清晰辨认该偶像的面部特征。其当时头戴黑色鸭舌帽试图遮掩，但仍被路人认出。</p>
      <h2>粉丝集体脱粉</h2>
      <p>照片曝光后，该偶像最大的粉丝后援会在两小时内宣布解散，并发布长文控诉偶像"欺骗粉丝感情""违背偶像职业道德"。更有多位前站姐和前线粉丝开始爆料该偶像过往的违规行为。</p>
      <p>据其中一位前站姐透露，该偶像至少从去年起就已恋爱，对象先后有三人，期间一直对粉丝隐瞒真相，并要求粉丝为其维护"清纯单身"人设。</p>
    `,
    relatedArticles: [2, 1],
    faq: [
      { question: '偶像为什么不能谈恋爱？', answer: '偶像行业普遍存在"恋爱禁令"，这是经纪公司和粉丝之间不成文的规则。偶像以贩卖"男友/女友"人设为核心商业模式，一旦恋爱会严重损害商业价值。' },
      { question: '这位偶像会因此退圈吗？', answer: '目前经纪公司尚未回应。但历史上类似事件中，当事人通常会暂停活动一段时间，待舆论冷却后再视情况决定是否回归。' },
    ],
    seoTitle: '偶像团体成员深夜约会素人粉丝集体脱粉回踩爆猛料 - 51爆料网',
    seoDescription: '某当红偶像团体成员被拍到深夜与素人约会举止亲密，粉丝后援会宣布解散并大面积脱粉。51爆料独家追踪事件来龙去脉。',
  },
  7: {
    id: 7,
    slug: 'daily-contest-variety-show-drama',
    title: '综艺节目录制现场爆发冲突，嘉宾当场离席拒绝录制',
    excerpt: '某热门综艺最新一期录制过程中，两位嘉宾因游戏环节产生争执，其中一位直接摔话筒离场。节目组已紧急暂停录制。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20tension%20atmosphere%20bright%20stage%20lights%20and%20dark%20shadows%20confrontation%20scene%20cinematic%20photography%20style%20professional%20broadcast%20setting&width=1200&height=600&seq=article-hero-07&orientation=landscape',
    author: {
      name: '综艺前线',
      avatar: 'https://readdy.ai/api/search-image?query=Entertainment%20reporter%20portrait%20professional%20look%20with%20headset%20studio%20background%20headshot%20photography&width=80&height=80&seq=author-07&orientation=squarish',
      role: '综艺线记者',
    },
    publishedAt: '2026-07-06T20:00:00',
    updatedAt: '2026-07-07T07:00:00',
    views: 567000,
    comments: 19800,
    tag: '独家',
    content: `
      <p>【51爆料独家报道】某热门综艺节目最新一期录制现场突发严重冲突，两位男性嘉宾在游戏环节产生激烈争执，其中一位当场摔话筒离场，导致录制中断超过两小时。</p>
      <h2>冲突始末</h2>
      <p>据现场工作人员透露，冲突发生在对抗类游戏环节。A嘉宾认为B嘉宾在游戏中使用了违规手段，双方由此爆发口角。从最初的言语争执迅速升级为激烈争吵，A嘉宾在情绪失控下将话筒摔在地上，随后径直离开录制现场。</p>
      <p>现场导演和其他嘉宾试图调解未果，录制被迫暂停。制片方紧急召开会议商讨应对方案。</p>
      <h2>节目组紧急公关</h2>
      <p>事件发生后，节目组迅速启动危机公关机制，要求所有现场人员签署保密协议。但仍有部分画面和录音流传出来，在网络上引发猜测。</p>
      <p>节目组官方随后发布简短声明，称"录制过程中因技术原因短暂中断，目前已完成全部录制，节目将按计划播出"。但这一说法与51爆料掌握的信息明显不符。</p>
    `,
    relatedArticles: [3, 5],
    faq: [
      { question: '是哪档综艺节目？', answer: '为保护相关当事人的合法权益暂不公开节目名称，但据播出档期和嘉宾阵容推断，应为近期黄金时段热播的某真人秀节目。' },
      { question: '节目还能正常播出吗？', answer: '据业内人士分析，由于冲突镜头无法使用，该期节目的素材可能会大幅缩减，或邀请其他嘉宾补录部分内容。正常播出存在不确定性。' },
    ],
    seoTitle: '综艺节目录制现场爆发冲突嘉宾摔话筒离席拒绝录制 - 51爆料网',
    seoDescription: '某热门综艺录制现场突发严重冲突，嘉宾当场摔话筒离席，节目组紧急暂停录制并启动危机公关。51爆料独家获取现场内幕。',
  },
  8: {
    id: 8,
    slug: 'daily-contest-actress-pregnancy',
    title: '当红女星疑似怀孕？宽松衣着现身机场，工作人员全程护驾',
    excerpt: '近日有网友拍到某当红女星现身机场，全程身穿宽松连衣裙，多名工作人员贴身保护。其与圈外男友已交往两年，婚讯传闻已久。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=Airport%20terminal%20scene%20with%20soft%20natural%20lighting%20busy%20travel%20atmosphere%20people%20walking%20in%20distance%20modern%20architecture%20cinematic%20style%20photography&width=1200&height=600&seq=article-hero-08&orientation=landscape',
    author: {
      name: '机场直击',
      avatar: 'https://readdy.ai/api/search-image?query=Female%20paparazzi%20photographer%20portrait%20urban%20style%20casual%20confident%20expression%20headshot%20photography&width=80&height=80&seq=author-08&orientation=squarish',
      role: '娱乐摄影记者',
    },
    publishedAt: '2026-07-06T16:00:00',
    updatedAt: '2026-07-07T10:00:00',
    views: 445000,
    comments: 15600,
    tag: '追踪',
    content: `
      <p>【51爆料独家报道】近日，有网友在首都机场拍到了某当红一线女星的出行画面。其全程身穿极为宽松的连衣裙，小腹处疑似有微微隆起，立刻引发网友对其怀孕的猜测。</p>
      <h2>机场画面引猜测</h2>
      <p>根据现场照片显示，该女星身穿一件oversize款式的碎花长裙，外搭宽松针织开衫，脚踩平底鞋。与平日里的紧身时尚风格大相径庭。其全程低头行走，用口罩和墨镜遮挡面容。</p>
      <p>更为引人注目的是，其身边至少有四名工作人员贴身跟随，形成"人墙"将周围拍照的人隔离开来。这种级别的保护在以往其出行中并不常见。</p>
      <h2>恋情背景</h2>
      <p>该女星于两年前公开了与圈外企业家男友的恋情，两人感情稳定。今年初曾多次传出婚讯，但其工作室始终以"有好消息会第一时间分享"作为回应。</p>
      <p>圈内人士透露，该女星近三个月已大幅减少工作量，推掉了多个综艺和影视项目。这与怀孕时间线高度吻合。</p>
    `,
    relatedArticles: [5, 2],
    faq: [
      { question: '这位女星真的怀孕了吗？', answer: '目前工作室尚未正面回应。但从其近期减少工作量、更改着装风格等多重迹象来看，怀孕的可能性较大。51爆料将持续跟踪此事。' },
      { question: '她会因此暂别娱乐圈吗？', answer: '按行业惯例，女星通常会在孕后期暂停工作，产后休养3-6个月后逐步复工。但具体安排取决于个人选择和家庭情况。' },
    ],
    seoTitle: '当红女星疑似怀孕宽松衣着现身机场工作人员全程护驾 - 51爆料网',
    seoDescription: '网友拍到某当红女星身穿宽松连衣裙现身机场，小腹疑似微隆，多名工作人员贴身保护。其与圈外男友交往两年婚讯传闻已久。51爆料独家追踪。',
  },
};

export const allArticleSlugs = [
  'top-star-scandal-leak',
  'influencer-divorce-dark-secret',
  'talent-show-rigging-exposed',
  'live-streamer-tax-evasion',
  'daily-contest-celebrity-feud',
  'daily-contest-idol-dating',
  'daily-contest-variety-show-drama',
  'daily-contest-actress-pregnancy',
];